import { render, staticRenderFns } from "./SlLayout.vue?vue&type=template&id=090efda2&"
import script from "./SlLayout.vue?vue&type=script&lang=js&"
export * from "./SlLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports